import footerController from './footer.controller.js';

function pageFooter() {
  return {
    template: require('./esp.pageFooter.html'),
    controller: footerController
  };
};
export default pageFooter;


// WEBPACK FOOTER //
// ./src/login/footer/esp.pageFooter.js